module.exports = {
    BUSINESS_NAME : "SalesHUB Lite",
    BUSINESS_ADDRESS : "NO 1/2/A Sample, Sample, Sample",
    BUSINESS_PHONE : "Tel: +94 77 222 2700",
    VERSION: "3.1.0"
}
